// import React from 'react';
// import { useParams } from 'react-router-dom';
// import "../CSS/BlogDetail.css";
// import BlogImg1 from "../Images/course pics.png"
// import BlogImg2 from "../Images/blogImg2.jpeg"
// import BlogImg3 from "../Images/blogimg3.jpeg"
// import { FaBackward } from 'react-icons/fa';

// const blogs = [
//     {
//       id: 1,
//       title: "The Future of Web Design",
//       excerpt: "Web design is evolving at a rapid pace. In this article, we explore the latest trends and what the future holds for web designers...",
//       content: "Web design is evolving at a rapid pace. In this article, we explore the latest trends and what the future holds for web designers. The future of web design is exciting, with new technologies and design philosophies emerging. One major trend is the increased use of AI in design, which allows for more personalized and efficient user experiences. Additionally, we see a move towards more interactive and immersive designs, utilizing technologies such as VR and AR. It's an exciting time to be a web designer!",
//       imgSrc: BlogImg1
//     },
//     {
//       id: 2,
//       title: "Effective Product Design",
//       excerpt: "Product design is crucial in today's competitive market. This article covers the key principles of effective product design and how to implement them...",
//       content: "Product design is crucial in today's competitive market. This article covers the key principles of effective product design and how to implement them. Effective product design starts with understanding the user. Designers need to conduct thorough research to understand the needs and pain points of their target audience. This information is then used to create user-centric designs that solve real problems. Additionally, designers need to be mindful of usability, aesthetics, and functionality, ensuring that the final product is both beautiful and practical.",
//       imgSrc: BlogImg2
//     },
//     {
//       id: 3,
//       title: "Mastering Front-End Development",
//       excerpt: "Front-end development is essential for creating responsive and interactive websites. Learn how to master front-end development with these tips and resources...",
//       content: "Front-end development is essential for creating responsive and interactive websites. Learn how to master front-end development with these tips and resources. Mastering front-end development requires a strong foundation in HTML, CSS, and JavaScript. Additionally, developers need to be proficient in frameworks like React, Angular, or Vue.js. It's also important to stay up-to-date with the latest trends and best practices, such as responsive design, performance optimization, and accessibility. Continuous learning and practice are key to becoming a proficient front-end developer.",
//       imgSrc: BlogImg3
//     },
//   ];
  

// const BlogDetail = () => {
//   const { id } = useParams();
//   const blog = blogs.find(blog => blog.id === parseInt(id));

//   return (
//     <div className='BlogDetail'>
//       <h1>{blog.title}</h1>
//       <img src={blog.imgSrc} alt={blog.title} className='DetailImage' />
//       <p>{blog.content}</p>
//       <button onClick={()=>window.history.back()}><FaBackward/> Back</button>
//     </div>
//   );
// };

// export default BlogDetail;




import React from 'react';
import { useParams } from 'react-router-dom';
import "../CSS/BlogDetail.css";
import { FaBackward, FaShareAlt } from 'react-icons/fa';
import BlogImg1 from "../Images/course pics.png";
import BlogImg2 from "../Images/blogImg2.jpeg";
import BlogImg3 from "../Images/blogimg3.jpeg";

const blogs = [
  {
    id: 1,
    title: "Future of Web Design",
    excerpt: "Web design is evolving at a rapid pace. In this article, we explore the latest trends and what the future holds for web designers...",
    content: "Web design is evolving at a rapid pace. In this article, we explore the latest trends and what the future holds for web designers. The future of web design is exciting, with new technologies and design philosophies emerging. One major trend is the increased use of AI in design, which allows for more personalized and efficient user experiences. Additionally, we see a move towards more interactive and immersive designs, utilizing technologies such as VR and AR. It's an exciting time to be a web designer!",
    imgSrc: BlogImg1
  },
  {
    id: 2,
    title: "Effective Product Design",
    excerpt: "Product design is crucial in today's competitive market. This article covers the key principles of effective product design and how to implement them...",
    content: "Product design is crucial in today's competitive market. This article covers the key principles of effective product design and how to implement them. Effective product design starts with understanding the user. Designers need to conduct thorough research to understand the needs and pain points of their target audience. This information is then used to create user-centric designs that solve real problems. Additionally, designers need to be mindful of usability, aesthetics, and functionality, ensuring that the final product is both beautiful and practical.",
    imgSrc: BlogImg2
  },
  {
    id: 3,
    title: "Mastering Front-End Development",
    excerpt: "Front-end development is essential for creating responsive and interactive websites. Learn how to master front-end development with these tips and resources...",
    content: "Front-end development is essential for creating responsive and interactive websites. Learn how to master front-end development with these tips and resources. Mastering front-end development requires a strong foundation in HTML, CSS, and JavaScript. Additionally, developers need to be proficient in frameworks like React, Angular, or Vue.js. It's also important to stay up-to-date with the latest trends and best practices, such as responsive design, performance optimization, and accessibility. Continuous learning and practice are key to becoming a proficient front-end developer.",
    imgSrc: BlogImg3
  },
];

const BlogDetail = () => {
  const { id } = useParams();
  const blog = blogs.find(blog => blog.id === parseInt(id));

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: blog.title,
        text: blog.content,
        url: window.location.href,
      }).catch(error => console.error('Error sharing', error));
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert("URL copied to clipboard");
    }
  };

  return (
    <div className='BlogDetail'>
      <h1>{blog.title}</h1>
      <img src={blog.imgSrc} alt={blog.title} className='DetailImage' />
      <p>{blog.content}</p>
      <button onClick={() => window.history.back()}><FaBackward /> Back</button>
      <button onClick={handleShare} style={{marginLeft:"10px"}}>
        <FaShareAlt /> Share
      </button>
     
    </div>
  );
};

export default BlogDetail;

